import { Range } from 'rc-slider'
import { useState } from 'react'

import css from './scss/Range.module.scss'
import { RangeProps } from './ts'

function RangeSlider({
  min = 0,
  max = 0,
  range = [0, max],
  onMove = () => null,
  onMoveEnd = () => null,
}: RangeProps) {
  const [transitionProperty, setTransitionProperty] = useState('all')

  const handleMove = (values: number[]) => {
    onMove(values)
    setTransitionProperty('none')
  }
  const handleMoveEnd = (values: number[]) => {
    onMoveEnd(values)
    setTransitionProperty('all')
  }

  return (
    <Range
      className={css.range}
      min={min}
      max={max}
      value={range}
      onChange={handleMove}
      onAfterChange={handleMoveEnd}
      trackStyle={[{ transitionProperty }]}
    />
  )
}

export default RangeSlider
